module.exports = __webpack_public_path__ + "assets/user-avatar-2588dfe14f5f12f6a913f450564fa6bf.png";